angular.module('app').controller('AboutSettingsCtrl',
    ['$scope', 'configuration', 'LocalStorageRepository', 'AprimaAnalytics', 'ServerInfoRepository',
        function ($scope, configuration, LocalStorageRepository, AprimaAnalytics, ServerInfoRepository) {
            'use strict';

            AprimaAnalytics.sendPageView('/Settings/About');

            $scope.clientID = LocalStorageRepository.getClientID();
            $scope.versionNumber = configuration.CLIENT_VERSION;
            $scope.gitCommitHash = configuration.GIT_COMMIT_HASH;
            $scope.gitCommitHashShort = configuration.GIT_COMMIT_HASH.substring(0,7);
            $scope.deviceId = LocalStorageRepository.getDeviceId();
            $scope.serverVersion = ServerInfoRepository.getMobileAssemblyVersion();
            $scope.prmVersion = ServerInfoRepository.getPrmAssemblyVersion();
            $scope.databaseVersion = ServerInfoRepository.getPrmDatabaseVersion();
            $scope.databaseBuild = ServerInfoRepository.getPrmDatabaseBuild();
        }]);
